/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/app.ts":
/*!********************!*\
  !*** ./src/app.ts ***!
  \********************/
/***/ (() => {

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  try {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  } catch (e) {
    return typeof fn === "function";
  }
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
// Custom-carousel component
// Custom-carousel component
// Custom-carousel component
var CustomCarousel = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomCarousel, _HTMLElement);
  var _super = _createSuper(CustomCarousel);
  function CustomCarousel() {
    var _this;
    _classCallCheck(this, CustomCarousel);
    _this = _super.call(this);
    function carouselCalc() {
      var carousel = this.querySelector(".carousel");
      var carouselBtns = Array.from(this.querySelectorAll(".sliderbtn")); // Convert NodeList to an array
      var cardWidth = this.querySelector(".carousel-card").offsetWidth;
      var carouselChildrens = Array.from(carousel.children);
      var childPerView = Math.round(carousel.offsetWidth / cardWidth);
      console.log(carousel.offsetWidth, cardWidth, childPerView);
      carouselChildrens.slice(-childPerView).reverse().forEach(function (child) {
        carousel.insertAdjacentHTML("afterbegin", child.outerHTML);
      });
      carouselChildrens.slice(0, childPerView).forEach(function (child) {
        carousel.insertAdjacentHTML("beforeend", child.outerHTML);
      });
      var _loop = function _loop() {
        var carouselBtn = _carouselBtns[_i];
        carouselBtn.addEventListener("click", function () {
          if (carouselBtn.getAttribute("data-direction") === "right") {
            carousel.scrollLeft += cardWidth;
          } else if (carouselBtn.getAttribute("data-direction") === "left") {
            carousel.scrollLeft -= cardWidth;
          }
        });
      };
      for (var _i = 0, _carouselBtns = carouselBtns; _i < _carouselBtns.length; _i++) {
        _loop();
      }
      carousel.addEventListener("scroll", scrollCarousel);
      function scrollCarousel() {
        if (carousel.scrollLeft === 0) {
          carousel.classList.remove("tw-scroll-smooth");
          carousel.scrollLeft = carousel.scrollWidth - 2 * carousel.offsetWidth;
          carousel.classList.add("tw-scroll-smooth");
        } else if (Math.ceil(carousel.scrollLeft) === carousel.scrollWidth - carousel.offsetWidth) {
          carousel.classList.remove("tw-scroll-smooth");
          carousel.scrollLeft = carousel.offsetWidth;
          carousel.classList.add("tw-scroll-smooth");
        }
      }
    }
    carouselCalc.call(_assertThisInitialized(_this));
    // Fire carouselCalc() when featured collection is changed
    var closestElement = _this.closest("featured-collections");
    var collectionTabs = closestElement ? Array.from(closestElement.querySelectorAll(".collection-tab")) : [];
    if (collectionTabs && collectionTabs.length > 1) {
      var _iterator = _createForOfIteratorHelper(collectionTabs),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var collectionTab = _step.value;
          collectionTab.addEventListener("click", function () {
            setTimeout(function () {
              carouselCalc.call(_assertThisInitialized(_this));
            }, 100);
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return _this;
  }
  return _createClass(CustomCarousel);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("custom-carousel", CustomCarousel);
// Custom-carousel component END
// Custom-carousel component END
// Custom-carousel component END
// Featured-collections component
// Featured-collections component
// Featured-collections component
var featuredCollections = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(featuredCollections, _HTMLElement2);
  var _super2 = _createSuper(featuredCollections);
  function featuredCollections() {
    var _this2;
    _classCallCheck(this, featuredCollections);
    _this2 = _super2.call(this);
    // get all collection tabs and featured collections
    var collectionTabs = Array.from(_this2.querySelectorAll(".collection-tab"));
    var _featuredCollections = Array.from(_this2.querySelectorAll(".featured-collection"));
    var _loop2 = function _loop2() {
      var collectionTab = _collectionTabs[_i2];
      collectionTab.addEventListener("click", function () {
        collectionTabs.forEach(function (collectionTab) {
          return collectionTab.classList.remove("collection-active-tab");
        });
        collectionTab.classList.add("collection-active-tab");
        _featuredCollections.forEach(function (featuredCollection) {
          return featuredCollection.classList.add("tw-hidden");
        });
        var collectionActive = _this2.querySelector(".featured-collection[data_collection_tab=\"".concat(collectionTab.getAttribute("collection_tab"), "\"]"));
        if (collectionActive) {
          collectionActive.classList.remove("tw-hidden");
        }
      });
    };
    for (var _i2 = 0, _collectionTabs = collectionTabs; _i2 < _collectionTabs.length; _i2++) {
      _loop2();
    }
    return _this2;
  }
  return _createClass(featuredCollections);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("featured-collections", featuredCollections);
// Featured-collections component END
// Featured-collections component END
// Featured-collections component END
// Logo-slider component
// Logo-slider component
// Logo-slider component
var logoList = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(logoList, _HTMLElement3);
  var _super3 = _createSuper(logoList);
  function logoList() {
    var _this3;
    _classCallCheck(this, logoList);
    _this3 = _super3.call(this);
    var logoCarousel = _this3.querySelector(".logocarousel");
    if (logoCarousel) {
      var logoContainerParent = _this3.querySelector(".logocarousel");
      var logoContainer = _this3.querySelector(".logo-list");
      var clonedLogos = logoContainer.cloneNode(true);
      var clonedLogosTwo = logoContainer.cloneNode(true);
      var clonedLogosThree = logoContainer.cloneNode(true);
      var clonedLogosFour = logoContainer.cloneNode(true);
      logoContainerParent.appendChild(clonedLogos);
      logoContainerParent.appendChild(clonedLogosTwo);
      logoContainerParent.appendChild(clonedLogosThree);
      logoContainerParent.appendChild(clonedLogosFour);
    }
    return _this3;
  }
  return _createClass(logoList);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("logo-list", logoList);
// Logo-slider component END
// Logo-slider component END
// Logo-slider component END
// Play-button component
// Play-button component
// Play-button component
var playButton = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(playButton, _HTMLElement4);
  var _super4 = _createSuper(playButton);
  function playButton() {
    var _this4;
    _classCallCheck(this, playButton);
    _this4 = _super4.call(this);
    var videoPlayButton = _this4.querySelector(".video_play_button");
    var videoPauseButton = _this4.querySelector(".video_pause_button");
    var videoElement = _this4.querySelector(".video_play");
    var videoContainer = _assertThisInitialized(_this4);
    videoContainer.addEventListener("mouseenter", function () {
      if (!videoElement.paused) {
        videoPlayButton.style.display = "none";
        videoPauseButton.style.display = "flex";
      } else {
        videoPlayButton.style.display = "flex";
        videoPauseButton.style.display = "none";
      }
    });
    videoContainer.addEventListener("mouseleave", function () {
      if (videoElement.paused) {
        videoPlayButton.style.display = "flex";
        videoPauseButton.style.display = "none";
      } else {
        videoPlayButton.style.display = "none";
        videoPauseButton.style.display = "none";
      }
    });
    videoPlayButton.addEventListener("click", function () {
      videoElement.play();
      videoPlayButton.style.display = "none";
      videoPauseButton.style.display = "flex";
    });
    videoPauseButton.addEventListener("click", function () {
      videoElement.pause();
      videoPlayButton.style.display = "flex";
      videoPauseButton.style.display = "none";
    });
    return _this4;
  }
  return _createClass(playButton);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("play-controls", playButton);
// Play-button component
// Play-button component
// Play-button component

/***/ }),

/***/ "./src/app.js":
/*!********************!*\
  !*** ./src/app.js ***!
  \********************/
/***/ (() => {



/***/ }),

/***/ "./src/app.scss":
/*!**********************!*\
  !*** ./src/app.scss ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/app": 0,
/******/ 			"assets/app": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkbasicandally"] = self["webpackChunkbasicandally"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.ts")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/app"], () => (__webpack_require__("./src/app.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;